import * as React from 'react'
import styled from 'styled-components'
import ToggleButton from 'LuxKit/ToggleButton'
import { getNavigationMenuIcon } from 'content/components/Icon/utils'
import AnimatedSparklesIcon from './AnimatedSparklesIcon'
import { AI_TRIP_PLANNER_NAV_ID } from './constants'

const FullWidthToggle = styled(ToggleButton)`
  width: 100%;
  min-width: 0;

  /* As per design, the primary toggle button should have a border color. */
  &&.kind-primary {
    border-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }
`

const ItemTitle = styled.span`
  white-space: normal;
`
interface Props {
  navItem: App.NavItem
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

function NavBarHamburgerMenuToggleItem(props: Props) {
  const { navItem, onClick } = props
  const iconName = navItem.sideNavIconName || navItem.iconName
  const DefaultIcon = iconName ? getNavigationMenuIcon(iconName) : undefined
  let startIcon = DefaultIcon ? <DefaultIcon /> : undefined

  if (navItem.id === AI_TRIP_PLANNER_NAV_ID) {
    startIcon = <AnimatedSparklesIcon />
  }

  return (
    <FullWidthToggle
      kind="primary"
      orientation="vertical"
      title={<ItemTitle>{navItem.text}</ItemTitle>}
      startIcon={startIcon}
      to={navItem.to}
      href={navItem.href}
      onClick={onClick}
    />
  )
}

export default NavBarHamburgerMenuToggleItem
